import React from "react";

export const Navigation = () => {
  return (
    <nav className="site-nav" aria-label="Primary navigation">
      <a className="brand-lockup page-scroll" href="#page-top" aria-label="Async Jam home">
        <img src="/img/jam.png" alt="" />
        <span>Async Jam</span>
      </a>
      <div className="nav-links">
        <a href="#projects" className="page-scroll">Projects</a>
        <a href="#about" className="page-scroll">Approach</a>
        <a href="#contact" className="page-scroll">Contact</a>
      </div>
    </nav>
  );
};
